import _ from 'lodash';
export function isNode(node) {
  return !!node.nodeName;
}
export function isElement(node) {
  return !!node.attrs;
}
export function isParentNode(node) {
  return !!node.childNodes;
}
export function isTextNode(node) {
  return node.nodeName === '#text';
} // export function toI18nKey(origin: string): string {
//   const lowered = origin.toLowerCase();
//   // Remove non-alnum
//   return lowered.replace(/[^a-z0-9 ]/g, '');
// }

export function toI18nKey(origin) {
  return origin.toLowerCase().replace(/[’.'!?]/g, '');
}
export function nl(num) {
  return _.repeat('\n', num);
} // Return `${a}${b}`, but the new lines between them are collapsed (the larger "newlines" is used).

export function collapsedConcat(head) {
  var strs = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    strs[_i - 1] = arguments[_i];
  }

  return _.reduce(strs, function (prevResult, currStr) {
    var trimmedA = _.trimEnd(prevResult, '\n');

    var trimmedB = _.trimStart(currStr, '\n');

    var numNL = Math.max(prevResult.length - trimmedA.length, currStr.length - trimmedB.length);
    return "" + trimmedA + nl(numNL) + trimmedB;
  }, head);
}